module.exports = __webpack_public_path__ + "static/img/shop_area_3.d643da48.jpg";